export default __webpack_public_path__ + "static/media/b5.360733e0.jpg";